import { siteInfo, heroStats } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] rounded-full bg-primary-100/30 blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-[600px] h-[600px] rounded-full bg-accent-100/20 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 pt-20 pb-16 md:pt-24 md:pb-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-sparkling-line"></i>
              <span>免费漫画 · 每日更新 · 高清阅读</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-900 leading-tight mb-4">
              樱花漫画网
              <span className="block text-2xl md:text-3xl lg:text-4xl text-primary-500 mt-2">
                免费漫画在线全集阅读平台
              </span>
            </h1>

            <p className="text-foreground-500 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteInfo.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="font-heading text-2xl md:text-3xl text-primary-500">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热门榜单
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-secondary-300 text-foreground-700 font-medium text-sm hover:bg-secondary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                探索漫画分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden bg-secondary-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20illustration%20of%20a%20girl%20reading%20manga%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20pink%20petals%20falling%20gently%2C%20warm%20spring%20sunlight%20filtering%20through%20branches%2C%20surrounded%20by%20floating%20comic%20books%20and%20magical%20sparkles%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20anime%20art%20style%20with%20clean%20lines%20and%20gentle%20shading%2C%20cozy%20and%20enchanting%20mood&width=960&height=1200&seq=hero-manga-main&orientation=portrait"
                alt="樱花漫画网 - 免费漫画在线阅读主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/15 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}